/**
 * @desc 重新上传面单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.LogisticsOrderResponseDto, options?: any) {
  return updateResponse(
    http(URL + `/test/test01`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
